// src/components/CookieBanner.js
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const STORAGE_KEY = "serveandcode_cookie_consent";

function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      setVisible(true);
    }
  }, []);

  const handleChoice = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
    // éventuelle activation / blocage de scripts non essentiels ici
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="cookie-banner">
      <div className="cookie-banner__inner">
        <p className="cookie-banner__text">
          {t("cookies.text")}
        </p>
        <div className="cookie-banner__actions">
          <button
            type="button"
            className="cookie-banner__button cookie-banner__button--reject"
            onClick={() => handleChoice("rejected")}
          >
            {t("cookies.reject")}
          </button>
          <button
            type="button"
            className="cookie-banner__button cookie-banner__button--accept"
            onClick={() => handleChoice("accepted")}
          >
            {t("cookies.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;
